import { useState } from "react";

import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useOutletApi } from "@/features/authentication";
import { ExpenseAccrualForm } from "@/features/expense-accruals";
import { getErrorMessage } from "@/features/shared";
import { PageContainer, useSnackbar } from "@/features/ui";

export const CreateExpenseAccrual = () => {
  const navigate = useNavigate();
  const outletApi = useOutletApi();
  const { showSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      const { outletId, ...payload } = data;

      await outletApi.post("expense-accruals", payload, {
        headers: { "Outlet-Id": outletId },
      });

      showSnackbar("Pencatatan beban berhasil dibuat", "success");
      navigate("/expense/expense-accruals");
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal membuat pencatatan beban"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Pencatatan Beban"
      breadcrumbs={[
        { title: "Pencatatan Beban", path: "/expense/expense-accruals" },
        { title: "Buat" },
      ]}
    >
      <ExpenseAccrualForm
        onSubmit={handleSubmit}
        renderActionButton={() => (
          <Button
            type="submit"
            variant="contained"
            disabled={isSubmitting}
            size="large"
          >
            {isSubmitting ? "Menyimpan..." : "Simpan"}
          </Button>
        )}
      />
    </PageContainer>
  );
};
